module.exports = __webpack_public_path__ + "c7cbd37aee71d62204ebd8a91633aa95.png";